export var TaxonomyType;
(function(TaxonomyType) {
    TaxonomyType["DISEASE_AREA"] = "disease_area";
    TaxonomyType["JOB_TYPE"] = "job_type";
    TaxonomyType["EVENT_TYPE"] = "event_type";
    TaxonomyType["EVENT_CATEGORY"] = "event_category";
    TaxonomyType["NEWS_CATEGORY"] = "news_category";
    TaxonomyType["LAB"] = "lab";
})(TaxonomyType || (TaxonomyType = {}));

//# sourceMappingURL=TaxonomyType.js.map